import { Box, Container, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { configuration } from '../configuration';
import { getTenant } from '../tenant-support/get-tenant';
import { win } from '../utilities/window';
import { getUserManager } from './auth-initialize';
import { bffLoginUrl, isCookieSession } from './bff-session';

function requestedIdentityProvider(): string | undefined {
  return new URLSearchParams(win.location.search).get('idp') || undefined;
}

/**
 * The way into Fasit for a caseworker asked to sign in: it starts the STS's own Apex STS login
 * flow, and a session that flow already made (at the DTE, say) answers it without a new login.
 */
export function Login() {
  const stsIsConfigured = Boolean(configuration.stsBaseAddress);

  useEffect(() => {
    if (!stsIsConfigured) {
      return;
    }

    const identityProvider = requestedIdentityProvider();

    if (isCookieSession()) {
      win.location.assign(bffLoginUrl(`${configuration.baseAddress}/`, { identityProvider, apexStsLogin: true }));
      return;
    }

    getUserManager()?.signinRedirect({
      acr_values: identityProvider ? `idp:${identityProvider}` : undefined,
      // these replace the configured extra query parameters rather than adding to them, so the tenant is named again
      extraQueryParams: { tenant: getTenant().name, useApexStsLogin: 'true' },
      state: { authenticationState: '/' },
    });
  }, [stsIsConfigured]);

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 8,
        }}
      >
        {stsIsConfigured ? (
          <Typography variant="body1">Sender dig videre til login...</Typography>
        ) : (
          <>
            <Typography component="h1" variant="h4" gutterBottom>
              Fejl ved login
            </Typography>
            <Typography variant="body1">Der er desværre gået noget galt ved login. Hvis du bliver ved med at få denne fejl, bør du kontakte Schultz kundesupport</Typography>
          </>
        )}
      </Box>
    </Container>
  );
}
